import { ControlAttributeType, } from "@cloudpivot/form/typings";
import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "visible", "style", "tips", "dataItemName", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                "mappings"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "拥有者" }),
        mappings: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("@cloudpivot/form/src/common/components/user-selection-map.vue"),
            options: {},
        },
    },
};
